var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm:max-h-96 sm:!min-h-[80%] sm:max-w-lg w-full sm:border sm:border-black sm:shadow-lg overflow-auto relative",attrs:{"id":"app","tabindex":"1"}},[_c('portal-target',{attrs:{"name":"modal"}}),_c('headerElem'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('FooterElem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }